export const formatMoney = (amount: number) => {
  const money = new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
  }).format(amount);

  // cut off trailing .00 if no cents
  return money.slice(-2) === '00' ? money.slice(0, -3) : money;
};
